import { releaseFeatures } from "@/config/releaseFeatures";
import { api } from "@/services/api";
import { userStore } from "@/redux/user";
import { browserPracticeTimezone } from "../puzzles/dailyPractice";
import { refreshLearning } from "./learningEvents";
import { recordGuestActivity } from "./guestLearningProgress";

export async function claimPuzzleStreak(
  source: "daily" | "theme",
  puzzleId: string | number,
  moves: string[],
) {
  if (!releaseFeatures.streaks) return;
  if (!userStore.getState().memberLoggedIn) {
    recordGuestActivity("puzzle", `${source}:${puzzleId}`);
    return;
  }
  try {
    await api.post(
      "/chess-streak/puzzle",
      { source, puzzleId, moves, timezone: browserPracticeTimezone() },
      { timeout: 15000 },
    );
    refreshLearning();
  } catch {
    // Leave the solved board intact. The player can retry saving without losing it.
    throw new Error("Could not save chess activity");
  }
}
